import { Box, Typography, Tooltip } from "@mui/material";
import type { ReactNode } from 'react';
import styles from "../../Leadgen.styles";

interface ItemProps {
  title: ReactNode;
  text: ReactNode;
  tooltipText?: string;
}
const Item = ({ title, text, tooltipText }: ItemProps) => {
  const stringText = typeof text === "string" ? text : undefined;
  const tooltipValue = tooltipText ?? (stringText && stringText.length > 10 ? stringText : "");
  const showTooltip = Boolean(tooltipValue);
  return (
    <Box sx={styles.infoRow}>
      <Typography sx={styles.contentTitle} variant="body2">
        {title}
      </Typography>
      <Box sx={styles.infoHolder}>
        <Tooltip
          title={showTooltip ? tooltipValue : ""}
          arrow
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: "#D3D3D3",
                color: "#495057",
                fontSize: "0.75rem",
                maxWidth: 300,
                padding: "8px 12px",
              },
            },
            arrow: {
              sx: {
                color: "#D3D3D3",
              },
            },
          }}
          disableHoverListener={!showTooltip}
        >
          <Typography sx={styles.contentSubTitle} variant="body2">
            {text}
          </Typography>
        </Tooltip>

      </Box>
    </Box>
  );
};

export default Item;
